import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useSuperAuth } from '../../contexts/SuperAuthContext';
import { CreditCard, LogOut, Shield } from 'lucide-react';

export default function SuperLayout() {
  const { logout, user } = useSuperAuth();
  const nav = useNavigate();

  const handleLogout = () => {
    logout();
    nav('/super/login');
  };

  const navItem = ({ isActive }) =>
    `flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors ${
      isActive
        ? 'bg-teal-500/15 text-teal-300 border border-teal-500/40'
        : 'text-slate-400 hover:text-white hover:bg-slate-800 border border-transparent'
    }`;

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <header className="border-b border-slate-800 px-6 py-4 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <Shield className="text-teal-400" size={22} />
          <div>
            <div className="font-semibold">Pizas · Super</div>
            <div className="text-xs text-slate-500">{user?.email}</div>
          </div>
        </div>
        <nav className="flex items-center gap-2 flex-wrap">
          <NavLink to="/super" end className={navItem}>
            <Shield size={16} /> Cliente
          </NavLink>
          <NavLink to="/super/suscripcion" className={navItem}>
            <CreditCard size={16} /> Suscripción
          </NavLink>
          <button
            type="button"
            onClick={handleLogout}
            className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-slate-400 hover:text-white hover:bg-slate-800"
          >
            <LogOut size={16} /> Salir
          </button>
        </nav>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
